import CorpCreateEdit from 'src/views/Pages/Dashboard/Crop/CropCreateEdit.vue';
import Crops from 'src/views/Pages/Dashboard/Crop/Crops.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import FarmCreateEdit from 'src/views/Pages/Dashboard/Farm/FarmCreateEdit.vue';
import Farms from 'src/views/Pages/Dashboard/Farm/Farms.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const FarmRoutes = {
  path: 'farms',
  component: MasterTab,
  props: { reference: 'farmTabs' },
  children: [
    {
      path: 'farms',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.farms',
          component: Farms,
          meta: {
            prefix_permission: 'farms_farms',
          },
        },
        {
          path: 'create',
          name: 'common_words.farms',
          component: FarmCreateEdit,
          meta: {
            prefix_permission: 'farms_farms',
          },
        },
        {
          path: 'edit',
          name: 'common_words.farms',
          component: FarmCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'farms_farms',
          },
        },
      ],
    },
    {
      path: 'crops',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.crops',
          component: Crops,
          meta: {
            prefix_permission: 'farms_crops',
          },
        },
        {
          path: 'create',
          name: 'common_words.crops',
          component: CorpCreateEdit,
          meta: {
            prefix_permission: 'farms_crops',
          },
        },
        {
          path: 'edit',
          name: 'common_words.crops',
          component: CorpCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'farms_crops',
          },
        },
      ],
    }
  ],
};

export default FarmRoutes;
